export const FETCH_PRODUCTS = 'product/FETCH_PRODUCTS'
export const FETCH_PRODUCTS_SUCCESS = 'product/FETCH_PRODUCTS_SUCCESS'
export const FETCH_PRODUCTS_FAILURE = 'product/FETCH_PRODUCTS_FAILURE'
export const RESET_PRODUCTS = 'product/RESET_PRODUCTS'

export const FETCH_PRODUCTS_OFFER = 'product/FETCH_PRODUCTS_OFFER'
export const FETCH_PRODUCTS_OFFER_SUCCESS = 'product/FETCH_PRODUCTS_OFFER_SUCCESS'
export const FETCH_PRODUCTS_OFFER_FAILURE = 'product/FETCH_PRODUCTS_OFFER_FAILURE'
export const RESET_PRODUCTS_OFFER = 'product/RESET_PRODUCTS_OFFER'

export const FETCH_PRODUCTS_STORES = 'product/FETCH_PRODUCTS_STORES'
export const FETCH_PRODUCTS_STORES_SUCCESS = 'product/FETCH_PRODUCTS_STORES_SUCCESS'
export const FETCH_PRODUCTS_STORES_FAILURE = 'product/FETCH_PRODUCTS_STORES_FAILURE'
export const RESET_PRODUCTS_STORES = 'product/RESET_PRODUCTS_STORES'

export const FETCH_PRODUCT = 'product/FETCH_PRODUCT'
export const FETCH_PRODUCT_SUCCESS = 'product/FETCH_PRODUCT_SUCCESS'
export const FETCH_PRODUCT_FAILURE = 'product/FETCH_PRODUCT_FAILURE'
export const RESET_PRODUCT = 'product/RESET_PRODUCT'

export const CREATE_PRODUCT = 'product/CREATE_PRODUCT'
export const CREATE_PRODUCT_SUCCESS = 'product/CREATE_PRODUCT_SUCCESS'
export const CREATE_PRODUCT_FAILURE = 'product/CREATE_PRODUCT_FAILURE'
export const RESET_CREATE_PRODUCT = 'product/RESET_CREATE_PRODUCT'

export const UPDATE_PRODUCT = 'product/UPDATE_PRODUCT'
export const UPDATE_PRODUCT_SUCCESS = 'product/UPDATE_PRODUCT_SUCCESS'
export const UPDATE_PRODUCT_FAILURE = 'product/UPDATE_PRODUCT_FAILURE'
export const RESET_UPDATE_PRODUCT = 'product/RESET_UPDATE_PRODUCT'

export const UPDATE_PRODUCT_STORES_STOCK = 'product/UPDATE_PRODUCT'
export const UPDATE_PRODUCT_STORES_STOCK_SUCCESS = 'product/UPDATE_PRODUCT_SUCCESS'
export const UPDATE_PRODUCT_STORES_STOCK_FAILURE = 'product/UPDATE_PRODUCT_FAILURE'
export const RESET_UPDATE_PRODUCT_STORES_STOCK = 'product/RESET_UPDATE_PRODUCT'

export const DELETE_PRODUCT = 'product/DELETE_PRODUCT'
export const DELETE_PRODUCT_SUCCESS = 'product/DELETE_PRODUCT_SUCCESS'
export const DELETE_PRODUCT_FAILURE = 'product/DELETE_PRODUCT_FAILURE'
export const RESET_DELETE_PRODUCT = 'product/RESET_DELETE_PRODUCT'

export const FETCH_PRODUCT_ORDERS = 'product/FETCH_PRODUCT_ORDERS'
export const FETCH_PRODUCT_ORDERS_SUCCESS = 'product/FETCH_PRODUCT_ORDERS_SUCCESS'
export const FETCH_PRODUCT_ORDERS_FAILURE = 'product/FETCH_PRODUCT_ORDERS_FAILURE'
export const RESET_PRODUCT_ORDERS = 'product/RESET_PRODUCT_ORDERS'

export const CREATE_PRODUCT_ORDER = 'product/CREATE_PRODUCT_ORDER'
export const CREATE_PRODUCT_ORDER_SUCCESS = 'product/CREATE_PRODUCT_ORDER_SUCCESS'
export const CREATE_PRODUCT_ORDER_FAILURE = 'product/CREATE_PRODUCT_ORDER_FAILURE'
export const RESET_CREATE_PRODUCT_ORDER = 'product/RESET_CREATE_PRODUCT_ORDER'

export const DELETE_PRODUCT_ORDER = 'product/DELETE_PRODUCT_ORDER'
export const DELETE_PRODUCT_ORDER_SUCCESS = 'product/DELETE_PRODUCT_ORDER_SUCCESS'
export const DELETE_PRODUCT_ORDER_FAILURE = 'product/DELETE_PRODUCT_ORDER_FAILURE'
export const RESET_DELETE_PRODUCT_ORDER = 'product/RESET_DELETE_PRODUCT_ORDER'


// WEBPACK FOOTER //
// ./src/store/product/actionTypes.js